import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Table, Params, Actions, Menu } from 'nallian-table-builder-ui';
import { DocumentStatus, DocumentType } from 'nallian-shared-ui/lib/layout/documents';
import { useTranslation } from 'react-i18next';
import apiRoutes from '../../../../app/api/routes';
import {
  INFINITE_SCROLL,
  TABS,
  PRINCIPAL_ACTIONS,
  PRINCIPAL_TABS,
  DOCUMENT_FILTER_SETTINGS,
  DOCUMENT_SORT_SETTINGS,
} from '../../constants';
import DocumentNameRenderer from '../principals/documents/DocumentNameRenderer';
import DocumentPreviewModal from '../principals/documents/DocumentPreviewModal';
import DocumentStatusFilter from './DocumentStatusFilter';
import DocumentTypeFilter from './DocumentTypeFilter';

const DocumentsOverviewTable = ({ organisationId, urlRoot }) => {
  const { t } = useTranslation(['app', 'shared']);

  const [previewItem, setPreviewItem] = useState(null);

  const handlePreviewClick = useCallback((_, item) => setPreviewItem(item), []);

  return (
    <>
      <Table
        infiniteScroll={INFINITE_SCROLL}
        resource={`organisationDocuments_${organisationId}`}
        url={apiRoutes.organisationPrincipalDocuments(organisationId)}
        noResultsMessage={t('documents.noDocumentsFound')}
        rootTableProperty="items"
        pageSize={50}
        filtered={DOCUMENT_FILTER_SETTINGS}
        sorted={DOCUMENT_SORT_SETTINGS}
        noUserSettings
      >
        <Actions.Button
          iconbutton
          width="2.5rem"
          align="center"
          icon="eye"
          onClick={handlePreviewClick}
        />
        <Params.String
          name="principalFullName"
          sortName="principalName"
          label="user"
          link={`${urlRoot}/${TABS.PRINCIPALS}/${PRINCIPAL_ACTIONS.DETAILS}/:principalId/${PRINCIPAL_TABS.DOCUMENTS}`}
          width="14rem"
          minWidth="14rem"
          grow
        />
        <Params.Custom
          name="documentType"
          label="documentType"
          content={DocumentType}
          filter={DocumentTypeFilter}
          width="16rem"
          minWidth="16rem"
          noSort
          grow
        />
        <Params.Custom
          name="fileName"
          label="documentName"
          content={DocumentNameRenderer}
          width="17rem"
          minWidth="17rem"
          grow
          noSort
          noFilter
        />
        <Params.Custom
          name="status"
          label="status"
          content={DocumentStatus}
          filter={DocumentStatusFilter}
          width="7rem"
          minWidth="7rem"
          noSort
        />
        <Params.DateTime
          name="expiresAt"
          label="expirationDate"
          sortName="expirationDate"
          width="10rem"
          noFilter
        />
        <Params.String
          name="uploadedBy.fullName"
          label="uploadedBy"
          width="10rem"
          minWidth="10rem"
          noFilter
          noSort
        />
        <Params.DateTime
          name="createdOn"
          label="uploadedAt"
          sortName="uploadedOn"
          width="10rem"
          noFilter
        />
        <Menu width="3.5rem" align="center">
          <Actions.Button
            icon="eye"
            label={t('documents.preview')}
            content={t('documents.preview')}
            onClick={handlePreviewClick}
          />
        </Menu>
      </Table>
      {previewItem && (
        <DocumentPreviewModal
          item={previewItem}
          principalId={previewItem.principalId}
          onClose={() => setPreviewItem(null)}
        />
      )}
    </>
  );
};

DocumentsOverviewTable.propTypes = {
  organisationId: PropTypes.string.isRequired,
  urlRoot: PropTypes.string.isRequired,
};

export default DocumentsOverviewTable;
